import { Box, Checkbox } from "@mui/material";
import styled from "styled-components";
import { BaseFormStyled } from "../../../../components/base-form/base-form.styles";

export const AppointmentReviewStyled = styled(Box)`
  .pet-details-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const BaseCards = styled(BaseFormStyled)`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 32px;
`;

export const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
}));
